export default __webpack_public_path__ + "static/media/sanitize.27a761bf.jpeg";